import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PhotoUpload from '@/pages/kitchendesignprice/components/PhotoUpload';
import { useState } from 'react';

export default function KitchenDesignPrice() {
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const textarea = form.querySelector('textarea[name="요청사항"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) {
      alert('요청사항은 500자 이내로 입력해주세요.');
      return;
    }

    // 시공항목 체크박스 최소 1개 선택 확인
    const checkedItems = form.querySelectorAll('input[name="시공항목"]:checked');
    if (checkedItems.length === 0) {
      setSubmitError('시공 희망 항목을 최소 1개 이상 선택해주세요.');
      return;
    }

    setSubmitError('');
    setSubmitting(true);

    try {
      const data = new FormData(form);
      const params = new URLSearchParams();

      // 체크박스 다중 선택값 올바르게 처리
      const checkboxValues: string[] = [];
      data.forEach((value, key) => {
        if (key === '시공항목') {
          checkboxValues.push(value as string);
        } else {
          params.append(key, value as string);
        }
      });
      if (checkboxValues.length > 0) {
        params.append('시공항목', checkboxValues.join(', '));
      }

      const res = await fetch('https://readdy.ai/api/form/d7eu0iaa509fjl5kvvpg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      if (!res.ok) {
        throw new Error(`서버 오류 (${res.status})`);
      }

      setSubmitted(true);
    } catch (err) {
      setSubmitError('견적 신청 중 오류가 발생했습니다. 잠시 후 다시 시도하거나 010-4016-8890으로 직접 연락해 주세요.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* 상단 배경 이미지 헤더 */}
      <div
        className="relative w-full h-64 md:h-80 flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bf29154d8668cb4b762f04032968a89d.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/45"></div>
        <div className="relative z-10 text-center px-6 pt-16">
          <p className="text-sm text-yellow-300 font-semibold mb-2 tracking-wide">대구 · 경북 지역 한정 무료 서비스</p>
          <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-3">
            무료 주방 견적 신청
          </h1>
          <p className="text-sm text-gray-200">
            아래 정보를 입력하시면 영업일 기준 1~2일 이내 견적을 보내드립니다.
          </p>
        </div>
      </div>

      <main className="flex-1 pb-20 px-6">
        <div className="max-w-2xl mx-auto">
          <div className="mb-10 mt-10">
          </div>

          {submitted ? (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-10 text-center">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 bg-yellow-400 rounded-full">
                <i className="ri-check-line text-2xl text-white"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">신청이 완료되었습니다!</h2>
              <p className="text-sm text-gray-600">영업일 기준 1~2일 이내 연락드리겠습니다.<br />이메일 문의: <a href="mailto:hanskid@naver.com" className="text-yellow-600 font-semibold hover:underline cursor-pointer">hanskid@naver.com</a><br />네이버 블로그로도 빠른 문의가 가능합니다. <a href="https://blog.naver.com/hanskid" target="_blank" rel="noopener noreferrer" className="text-green-600 font-semibold hover:underline cursor-pointer">블로그 바로가기</a></p>
              <a
                href="/"
                className="inline-flex items-center justify-center mt-6 px-8 py-3 bg-yellow-400 text-gray-900 font-bold text-sm rounded-md hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                홈으로 돌아가기
              </a>
            </div>
          ) : (
            <form
              id="daegu-kitchens-estimate-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col gap-6"
            >
              {/* 이름 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">이름 <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="이름"
                  required
                  placeholder="홍길동"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400"
                />
              </div>

              {/* 연락처 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">연락처 <span className="text-red-500">*</span></label>
                <input
                  type="tel"
                  name="연락처"
                  required
                  placeholder="010-0000-0000"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400"
                />
              </div>

              {/* 이메일 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">이메일</label>
                <input
                  type="email"
                  name="email"
                  placeholder="example@email.com"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400"
                />
              </div>

              {/* 지역 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">시공 지역 <span className="text-red-500">*</span></label>
                <select
                  name="시공지역"
                  required
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 bg-white cursor-pointer"
                >
                  <option value="">지역을 선택해주세요</option>
                  <option value="대구 달서구">대구 달서구</option>
                  <option value="대구 수성구">대구 수성구</option>
                  <option value="대구 북구">대구 북구</option>
                  <option value="대구 동구">대구 동구</option>
                  <option value="대구 서구">대구 서구</option>
                  <option value="대구 남구">대구 남구</option>
                  <option value="대구 중구">대구 중구</option>
                  <option value="대구 달성군">대구 달성군</option>
                  <option value="경북 구미">경북 구미</option>
                  <option value="경북 경산">경북 경산</option>
                  <option value="경북 포항">경북 포항</option>
                  <option value="경북 안동">경북 안동</option>
                  <option value="경북 기타">경북 기타</option>
                </select>
              </div>

              {/* 주택 유형 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">주택 유형 <span className="text-red-500">*</span></label>
                <select
                  name="주택유형"
                  required
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 bg-white cursor-pointer"
                >
                  <option value="">유형을 선택해주세요</option>
                  <option value="아파트">아파트</option>
                  <option value="빌라/연립">빌라/연립</option>
                  <option value="단독주택">단독주택</option>
                  <option value="오피스텔">오피스텔</option>
                  <option value="상가/사무실">상가/사무실</option>
                </select>
              </div>

              {/* 평수 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">주방 평수 (대략) <span className="text-red-500">*</span></label>
                <select
                  name="주방평수"
                  required
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 bg-white cursor-pointer"
                >
                  <option value="">평수를 선택해주세요</option>
                  <option value="10평 미만">10평 미만</option>
                  <option value="10~20평">10~20평</option>
                  <option value="20~30평">20~30평</option>
                  <option value="30~40평">30~40평</option>
                  <option value="40평 이상">40평 이상</option>
                </select>
              </div>

              {/* 시공 희망 항목 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-2">시공 희망 항목 <span className="text-red-500">*</span></label>
                <div className="grid grid-cols-2 gap-2">
                  {['싱크대 교체', '상부장 교체', '하부장 교체', '키큰장 설치', '아일랜드 설치', '전체 주방 리모델링'].map((item) => (
                    <label key={item} className="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                      <input type="checkbox" name="시공항목" value={item} className="accent-yellow-400 w-4 h-4" />
                      {item}
                    </label>
                  ))}
                </div>
              </div>

              {/* 시공 희망 시기 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">시공 희망 시기</label>
                <select
                  name="시공희망시기"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 bg-white cursor-pointer"
                >
                  <option value="">시기를 선택해주세요</option>
                  <option value="1개월 이내">1개월 이내</option>
                  <option value="1~3개월 이내">1~3개월 이내</option>
                  <option value="3~6개월 이내">3~6개월 이내</option>
                  <option value="미정">미정</option>
                </select>
              </div>

              {/* 예산 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">예산 범위</label>
                <select
                  name="예산범위"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 bg-white cursor-pointer"
                >
                  <option value="">예산을 선택해주세요</option>
                  <option value="100만원 미만">100만원 미만</option>
                  <option value="100~300만원">100~300만원</option>
                  <option value="300~500만원">300~500만원</option>
                  <option value="500~800만원">500~800만원</option>
                  <option value="800만원 이상">800만원 이상</option>
                  <option value="미정">미정</option>
                </select>
              </div>

              {/* 현장사진 첨부 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">현장사진 첨부 <span className="text-gray-400 font-normal">(선택)</span></label>
                <PhotoUpload />
              </div>

              {/* 요청사항 */}
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">요청사항 및 현재 주방 상태</label>
                <textarea
                  name="요청사항"
                  rows={4}
                  maxLength={500}
                  placeholder="현재 주방 상태, 원하는 스타일, 특이사항 등을 자유롭게 적어주세요. (최대 500자)"
                  className="w-full border border-gray-200 rounded-md px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 resize-none"
                  onChange={(e) => setCharCount(e.target.value.length)}
                />
                <p className="text-xs text-gray-400 text-right mt-1">{charCount}/500</p>
              </div>

              {/* 개인정보 동의 */}
              <div className="bg-gray-50 rounded-md p-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input type="checkbox" name="개인정보동의" value="동의" required className="accent-yellow-400 w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="text-xs text-gray-600 leading-relaxed">
                    개인정보 수집 및 이용에 동의합니다. 수집된 정보는 견적 안내 목적으로만 사용되며, 서비스 완료 후 즉시 파기됩니다. <span className="text-red-500">*</span>
                  </span>
                </label>
              </div>

              {submitError && (
                <div className="bg-red-50 border border-red-200 rounded-md px-4 py-3 text-sm text-red-600 flex items-start gap-2">
                  <i className="ri-error-warning-line mt-0.5 flex-shrink-0"></i>
                  <span>{submitError}</span>
                </div>
              )}

              <button
                type="submit"
                disabled={submitting}
                className="w-full py-4 bg-yellow-400 text-gray-900 font-bold text-base rounded-md hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {submitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    신청 중...
                  </>
                ) : '무료 견적 신청하기'}
              </button>

              <p className="text-xs text-gray-400 text-center">
                * 대구 / 경북 지역 한정 서비스입니다. 영업일 기준 1~2일 이내 연락드립니다.
              </p>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
